const envConfigs = {
  local: {
    baseURL: 'http://localhost/hemat-api/api',
    baseURLProjectPdf: 'http://localhost/hemat-api',
    baseURLPdf: 'http://localhost/hemat-api/api/pdf/projek/',
    portalURL: 'http://10.21.1.20/index.php',
  },
  pre: {
    baseURL: 'http://10.21.1.123/hemat-api/api',
    baseURLProjectPdf: 'http://10.21.1.123/hemat-api',
    baseURLPdf: 'http://10.21.1.123/hemat-api/api/pdf/projek/',
    portalURL: 'http://10.21.1.20/index.php',
  },
  prod: {
    baseURL: 'https://ehemat.jpa.gov.my/hemat-api/api',
    baseURLProjectPdf: 'https://ehemat.jpa.gov.my/hemat-api',
    baseURLPdf: 'https://ehemat.jpa.gov.my/hemat-api/api/pdf/projek/',
    portalURL: 'https://hemat.jpa.gov.my',
  },
};

// Set the active environment ('local', 'pre', or 'prod')
// const activeEnv = 'local' ;
// const activeEnv = 'pre';
const activeEnv = 'prod';

// Export the active configuration
export const { baseURL, baseURLPdf, portalURL, hrmisURL, baseURLProjectPdf } = envConfigs[activeEnv];
